module.exports = new __parcel__URL__("iphone.57827c60.png").toString();